// @ts-strict-ignore
/**
 * This file contains selectors that handle graph & action data.
 * Webpack module resolution results in nested selectors that have a circular-like
 * dependency graph to be undefined when the selector files are first evaluated.
 *
 * The solution is to either refactor every selector into the same file, or isolate
 * cross-domain selectors like this one into its own file.
 *
 * https://github.com/reduxjs/reselect/issues/169#issuecomment-675021575
 */

import { createSelector } from 'reselect';
import { selectNodeLineageForAnchorNode } from './graph';
import type { State } from '~/store';


export const selectDirectDependentActions = createSelector(
  [
    selectNodeLineageForAnchorNode,
    (state: State) => state.workflowEditor.workflowData?.actions,
  ],
  (nodeLineage, actions) => (
    [...nodeLineage.directOutgoers].map(id => actions[id])),
);
